import { render, staticRenderFns } from "./HCCStats.vue?vue&type=template&id=acfe85e0&scoped=true&"
import script from "./HCCStats.vue?vue&type=script&lang=js&"
export * from "./HCCStats.vue?vue&type=script&lang=js&"
import style0 from "./HCCStats.vue?vue&type=style&index=0&id=acfe85e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfe85e0",
  null
  
)

export default component.exports